import {
  Menu,
  MenuItem,
  FormControlLabel,
  Divider,
  Grid2,
  IconButton,
  Tooltip,
  Checkbox,
  Collapse
} from "@mui/material";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialTypography from "../../../../components/MaterialTypography";
import { ExpandMore, FilterAltOff } from "@mui/icons-material";
import { useLoading } from "../../../../components/Loading";
import { useState } from "react";
import { useSnackbar } from "../../../../context/popup";
import { fetchData } from "../../../../services";


const ApiCategoryFilterDialog = ({ anchorEl, open, onClose, filterData, setFilterData, onApply }) => {    
    
    const { setCircleLoading } = useLoading();
    const {showSnackbar} = useSnackbar();

    //accordian states
    const [openActive, setOpenActive] = useState(false);
    const [openInsurer, setOpenInsurer] = useState(false);


    //options states
    const [options, setOptions] = useState([]); 

    const sectionHeader = {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "6px 8px",
        background: "#e9ecf5",
        borderRadius: "6px",
        cursor: "pointer",
        mb: 0.5,
    };

    const menuItemStyle = {
        borderRadius: "6px",
        my: 0.2,
        mx: 0.5,
        py: 0.3,
        "&:hover": { backgroundColor: "#dfe6ff" },
    };

    const labelStyle = {
        m: 0,
        "& .MuiFormControlLabel-label": { fontSize: "0.8rem" },
    };

    const fetchParentCategoryList = async () => {
        setCircleLoading(true);
        try {
            const response = await fetchData(`/api-engine/key-value-category?dropdown=true&isActive=true`)
            
            if(response?.success){
                const formattedOptions = response?.data?.items?.map((item) => ({
                    value: item?.id,
                    label: item?.categoryName,
                })) || [];
                setOptions(formattedOptions)
            }
            else{
                //throw error
                showSnackbar("Error Fetching List", "error")
            }
        } catch (error) {
            console.error('Error Fetching Dropdown:', error);
            showSnackbar(error?.response?.data?.message || "Network Error", "error");
        }
        finally{
            setCircleLoading(false);
        }
    };  

    const handleChange = ({ target: { name, value } }) => {
        setFilterData(prev => ({
            ...prev,
            [name]: value
        }));
    };


    const onClearFilters = () => {
        setFilterData({
            isActive: "",
            parentCategoryId: ""
        });
    };


  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      sx={{backgroundColor: "rgba(0, 0, 0, 0.3)",}}
      PaperProps={{
          elevation: 3,
          sx: {
            width: 250,
            padding: 1.5,
          },
      }}
    >
        <MaterialBox
        sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",             
        }}
        >
            {/* Title */}
            <MaterialTypography variant="body2" fontWeight="bold">
                API Category Filter
            </MaterialTypography>

            {/* Clear Button */}
            <Tooltip title="Clear Filter" disableInteractive>
                <IconButton
                    size="small"
                    onClick={onClearFilters}
                    sx={{ color: "#ce0707ff" }}
                >
                    <FilterAltOff />
                </IconButton>
            </Tooltip>
        </MaterialBox>


      {/* Content */}
        <MaterialBox ml={1} mt={1} sx={{
            maxHeight: 300, 
            overflowY: "auto"}}>
            <Grid2 container>
                <Grid2 size={{xs:12}}>
                    <MaterialBox mt={1}>
                        <MaterialBox sx={sectionHeader} onClick={() => setOpenActive(!openActive)}>
                        <MaterialTypography variant="subtitle2" fontWeight="bold">
                            Active Status
                        </MaterialTypography>

                        <IconButton size="small">
                            <ExpandMore
                            sx={{
                                transform: openActive ? "rotate(180deg)" : "rotate(0deg)",
                                transition: "0.2s",
                            }}
                            />
                        </IconButton>
                        </MaterialBox>

                        <Collapse in={openActive}>
                        <MenuItem
                            disableRipple
                            sx={menuItemStyle}
                            onClick={() =>
                            handleChange({
                                target: { name: "isActive", value: true },
                            })
                            }
                        >
                            <FormControlLabel
                            control={<Checkbox size="small" checked={filterData.isActive === true} />}
                            label="Active"
                            sx={labelStyle}
                            />
                        </MenuItem>

                        <MenuItem
                            disableRipple
                            sx={menuItemStyle}
                            onClick={() =>
                            handleChange({
                                target: { name: "isActive", value: false },
                            })
                            }
                        >
                            <FormControlLabel
                            control={<Checkbox size="small" checked={filterData.isActive === false} />}
                            label="Inactive"
                            sx={labelStyle}
                            />
                        </MenuItem>
                        </Collapse>
                    </MaterialBox>
                </Grid2>
                {/* Parent Category*/}
                <Grid2 size={{xs:12}}>
                    <MaterialBox>
                        <MaterialBox sx={sectionHeader} onClick={() => {
                            const nextState = !openInsurer;
                            setOpenInsurer(nextState);

                            if (nextState && options.length === 0) {
                                fetchParentCategoryList();
                            }
                        }}>
                        <MaterialTypography variant="subtitle2" fontWeight="bold">
                            Parent Category
                        </MaterialTypography>

                        <IconButton size="small">
                            <ExpandMore
                            sx={{
                                transform: openInsurer ? "rotate(180deg)" : "rotate(0deg)",
                                transition: "0.2s",
                            }}
                            />
                        </IconButton>
                        </MaterialBox>

                        <Collapse in={openInsurer}>
                        {options?.map((item) => (
                            <MenuItem
                            key={item.value}
                            disableRipple
                            sx={menuItemStyle}
                            onClick={() =>
                                handleChange({
                                target: { name: "parentCategoryId", value: item.value },
                                })
                            }
                            >
                            <FormControlLabel
                                control={<Checkbox size="small" checked={filterData.parentCategoryId === item.value} />}
                                label={item.label}
                                sx={labelStyle}
                            />
                            </MenuItem>
                        ))}
                        </Collapse>
                    </MaterialBox>
                </Grid2>
            </Grid2>
        </MaterialBox>

        <Divider />

        {/* Apply button */}
        <MenuItem
        onClick={() => onApply()}
        disableRipple
        sx={{
            padding: "6px 16px", 
            width: "fit-content",
            mx: "auto",  
            borderRadius: "6px",
            backgroundColor: "#93a6e8",
            color: "white",
            display: "flex",
            justifyContent: "center",
            transition: "0.2s ease",

            "&:hover": {
            backgroundColor: "#bcc7e9",
            }
        }}
        >
        <MaterialTypography variant="button" fontWeight="bold">
            APPLY FILTER
        </MaterialTypography>
        </MenuItem>
    </Menu>
  );
};

export default ApiCategoryFilterDialog;
